import { render, staticRenderFns } from "./PagePost.vue?vue&type=template&id=11be0de4&"
import script from "./PagePost.vue?vue&type=script&lang=ts&"
export * from "./PagePost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports